var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V7H10C8.34315 7 7 8.34315 7 10V16H4C2.89543 16 2 15.1046 2 14V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10C9.75 9.86193 9.86193 9.75 10 9.75H11.375C11.7892 9.75 12.125 9.41421 12.125 9C12.125 8.58579 11.7892 8.25 11.375 8.25H10C9.0335 8.25 8.25 9.0335 8.25 10V11.375C8.25 11.7892 8.58579 12.125 9 12.125C9.41421 12.125 9.75 11.7892 9.75 11.375V10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 8.25C13.7108 8.25 13.375 8.58579 13.375 9C13.375 9.41421 13.7108 9.75 14.125 9.75H16.875C17.2892 9.75 17.625 9.41421 17.625 9C17.625 8.58579 17.2892 8.25 16.875 8.25H14.125Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 8.25C19.2108 8.25 18.875 8.58579 18.875 9C18.875 9.41421 19.2108 9.75 19.625 9.75H21C21.1381 9.75 21.25 9.86193 21.25 10V11.375C21.25 11.7892 21.5858 12.125 22 12.125C22.4142 12.125 22.75 11.7892 22.75 11.375V10C22.75 9.0335 21.9665 8.25 21 8.25H19.625Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 14.125C9.75 13.7108 9.41421 13.375 9 13.375C8.58579 13.375 8.25 13.7108 8.25 14.125V16.875C8.25 17.2892 8.58579 17.625 9 17.625C9.41421 17.625 9.75 17.2892 9.75 16.875V14.125Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 14.125C22.75 13.7108 22.4142 13.375 22 13.375C21.5858 13.375 21.25 13.7108 21.25 14.125V16.875C21.25 17.2892 21.5858 17.625 22 17.625C22.4142 17.625 22.75 17.2892 22.75 16.875V14.125Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 19.625C9.75 19.2108 9.41421 18.875 9 18.875C8.58579 18.875 8.25 19.2108 8.25 19.625V21C8.25 21.9665 9.0335 22.75 10 22.75H11.375C11.7892 22.75 12.125 22.4142 12.125 22C12.125 21.5858 11.7892 21.25 11.375 21.25H10C9.86193 21.25 9.75 21.1381 9.75 21V19.625Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 19.625C22.75 19.2108 22.4142 18.875 22 18.875C21.5858 18.875 21.25 19.2108 21.25 19.625V21C21.25 21.1381 21.1381 21.25 21 21.25H19.625C19.2108 21.25 18.875 21.5858 18.875 22C18.875 22.4142 19.2108 22.75 19.625 22.75H21C21.9665 22.75 22.75 21.9665 22.75 21V19.625Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 21.25C13.7108 21.25 13.375 21.5858 13.375 22C13.375 22.4142 13.7108 22.75 14.125 22.75H16.875C17.2892 22.75 17.625 22.4142 17.625 22C17.625 21.5858 17.2892 21.25 16.875 21.25H14.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusFront);
export default __webpack_public_path__ + "static/media/minus-front.72948ed6b6d52496c1fa9f61acf5f0c2.svg";
export { ForwardRef as ReactComponent };